import { format } from "date-fns";

// ------------------------------------------ TRATAMENTO DE ARQUIVOS E DOWNLOADS ---------------------------------
export function baixarBlob(blob: Blob, nomeArquivo: string): void {
	const objectUrl = URL.createObjectURL(blob);
	const link = document.createElement("a");
	link.href = objectUrl;
	link.download = nomeArquivo;
	link.style.display = "none";

	document.body.appendChild(link);
	link.click();
	link.remove();
	URL.revokeObjectURL(objectUrl);
}

export type ResultadoImpressaoBlob = "printed" | "preview";

export function imprimirBlob(blob: Blob, printWindow: Window): Promise<ResultadoImpressaoBlob> {
	return new Promise((resolve, reject) => {
		if (!blob.size) {
			reject(new Error("O arquivo para impressão está vazio."));
			return;
		}

		if (printWindow.closed) {
			reject(new Error("A janela de impressão foi fechada."));
			return;
		}

		let objectUrl: string;
		try {
			objectUrl = URL.createObjectURL(blob);
		} catch {
			reject(new Error("Não foi possível preparar o arquivo para impressão."));
			return;
		}

		let loadTimeout: ReturnType<typeof setTimeout> | undefined;
		let isSettled = false;

		const revokeObjectUrlLater = () => {
			setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
		};

		const finish = (result: ResultadoImpressaoBlob) => {
			if (isSettled) return;
			isSettled = true;
			if (loadTimeout) clearTimeout(loadTimeout);
			revokeObjectUrlLater();
			resolve(result);
		};

		const fail = (error: Error) => {
			if (isSettled) return;
			isSettled = true;
			if (loadTimeout) clearTimeout(loadTimeout);
			URL.revokeObjectURL(objectUrl);
			reject(error);
		};

		const handleLoad = () => {
			if (isSettled) return;

			try {
				printWindow.focus();
				printWindow.print();
				finish("printed");
			} catch {
				finish("preview");
			}
		};

		try {
			printWindow.addEventListener("load", handleLoad, { once: true });
			loadTimeout = setTimeout(() => finish("preview"), 15_000);
			printWindow.location.replace(objectUrl);
		} catch {
			fail(new Error("Não foi possível abrir o arquivo para impressão."));
		}
	});
}

export type ExtensaoArquivo = "pdf" | "xlsx" | "png" | "txt";
export function montarNomeArquivo(identificador: string, source: ExtensaoArquivo, complemento = "generico"): string {
	const dataHora = format(new Date(), "yyyyMMdd-HHmmss-SSS");

	const complementoFinal = complemento.trim() || "generico";
	const identificadorFinal = identificador.trim() || "arquivo";

	return `${complementoFinal}-${identificadorFinal}-${dataHora}.${source}`;
}

export function formatarTamanhoArquivo(bytes: number): string {
	if (!Number.isFinite(bytes) || bytes < 0) return "—";

	const unidades = ["B", "KB", "MB", "GB"] as const;
	let valor = bytes;
	let unidadeIndex = 0;

	while (valor >= 1024 && unidadeIndex < unidades.length - 1) {
		valor /= 1024;
		unidadeIndex++;
	}

	const maximumFractionDigits = unidadeIndex === 0 ? 0 : 2;
	return `${new Intl.NumberFormat("pt-BR", { maximumFractionDigits }).format(valor)} ${unidades[unidadeIndex]}`;
}
